import { MainProvider } from "./providers";
import { MainRoutes } from "./routes";

export default function App() {
  return (
    <MainProvider>
      <MainRoutes />
    </MainProvider>
  );
}
